import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints, theme } from '../../constants/theme'

const { typography } = dsTheme

export const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.backgroundColor};
  @media ${progressiveBreakpoints.desktopSmall} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  @media ${progressiveBreakpoints.desktop} {
    justify-content: center;
  }
`

export const CountdownColumn = styled.div`
  display: flex;
  justify-content: center;
  @media ${progressiveBreakpoints.desktop} {
    width: 35%;
    justify-content: space-between;
  }
  @media (min-width: 1300px) {
    width: 20%;
    justify-content: flex-end;
    margin-right: 2rem;
  }
  ${(props) =>
    props.withNumbers &&
    `
    justify-content: space-evenly;
    padding: 0 1rem 1rem 1rem;
    text-align: center;
    width: 100%;
    @media ${progressiveBreakpoints.desktopSmall} {
      padding: 0;
      width: 25%;
    }
    @media (min-width: 1300px) {
      justify-content: flex-start;
    }
`}
`

export const Time = styled.div`
  display: flex;
  flex-direction: column;
  @media ${progressiveBreakpoints.desktopSmall} {
    flex-direction: row;
  }
`

export const Text = styled.p`
  margin-top: 1rem;
  color: ${theme.colors.background.backgroundColorDarkest};
  ${typography['Kollektif/Large']};
`
export const SmallText = styled.p`
  color: ${theme.colors.background.backgroundColorDarkest};
  ${typography['Kollektif/SmallEmphasis']};

  @media ${progressiveBreakpoints.desktopSmall} {
    margin: 1.25rem 1rem 1.25rem 0.5rem;
  }
`

export const Link = styled.a`
  text-decoration: none;
`
